export enum CompanyCodeEnum {
  ROYAL = "MQ==",
}
